"use client";
import { Box, Center, Separator } from "@chakra-ui/react";
import SimpleIntro from "@/components/simpleIntro";
import { Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { INTRO_CONSTANTS } from "./constants";

const IntroComponent = () => {
  return (
    <Box>
      <SimpleIntro {...INTRO_CONSTANTS} />
      <Center>
        <Button variant={"ideal"} onClick={() => scrollToElement("pricing", 120)} mt={8}>
          {INTRO_CONSTANTS.btnText}
        </Button>
      </Center>
      <Separator
        borderWidth="2px"
        borderColor="#ECECEC"
        mt={10}
        mb={{ base: -10, md: 0 }}
      />
    </Box>
  );
};

export default IntroComponent;
